// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReDate from "@mobily/rescript-date/src/ReDate.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../../../intl/Intl_Utils.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../../../common/components/App_LabeledText.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../../../intl/messages/Messages_Common.bs.js";
import * as Messages_Orders_Detail$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_Detail.bs.js";
import * as Order_Detail_Correct_Box$DvmAdminFrontendFr from "../Order_Detail_Correct_Box.bs.js";

function Order_Detail_Correct_Vehicle_Content(Props) {
  var usedCarDetail = Props.usedCarDetail;
  var color = Props.color;
  var title = Props.title;
  var newestUndeployedCorrection = Props.newestUndeployedCorrection;
  var form = Props.form;
  var intl = ReactIntl.useIntl();
  var checkEmptyString = function (string) {
    return Belt_Option.mapWithDefault(string, undefined, (function (x) {
                  if (x.length > 0) {
                    return x;
                  }
                  
                }));
  };
  var usedCarDetail$1 = Belt_Option.getWithDefault(usedCarDetail, {
        orderUcBrand: undefined,
        orderUcModel: undefined,
        orderUcVersion: undefined,
        orderUcRegistrationId: undefined,
        orderUcVin: undefined,
        ucPoliceNumber: undefined,
        orderUCFirstReleaseDate: undefined,
        orderUCLastRegistrationDate: undefined,
        orderRealTradeAmount: undefined,
        orderEstimatedTradeAmount: undefined,
        orderScrapyardIndicator: undefined
      });
  var match = Belt_Option.mapWithDefault(newestUndeployedCorrection, [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      ], (function (x) {
          return [
                  Belt_Option.mapWithDefault(checkEmptyString(x.usedCarPoliceNumber), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.ucPoliceNumber, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.usedCarLastRegistrationDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(usedCarDetail$1.orderUCLastRegistrationDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.usedCarRegistrationID), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderUcRegistrationId, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.usedCarFirstReleaseDate, "", (function (x) {
                          if (ReDate.isSameDay(x, Belt_Option.getWithDefault(usedCarDetail$1.orderUCFirstReleaseDate, new Date(0.0)))) {
                            return "";
                          } else {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatDate(intl, x) + ")";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.brandUsedCar), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderUcBrand, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.modelUsedCar), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderUcModel, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.versionUsedCar), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderUcVersion, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(checkEmptyString(x.vinUsedCar), "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderUcVin, "")) {
                            return " (" + x + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.realTradeAmount, "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderRealTradeAmount, 0.0)) {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x) + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.estimatedTradeAmount, "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderEstimatedTradeAmount, 0.0)) {
                            return " (" + Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x) + ")";
                          } else {
                            return "";
                          }
                        })),
                  Belt_Option.mapWithDefault(x.scrapyardIndicator, "", (function (x) {
                          if (x !== Belt_Option.getWithDefault(usedCarDetail$1.orderScrapyardIndicator, false)) {
                            return " (" + intl.formatMessage(x ? Messages_Common$DvmAdminFrontendFr.yes : Messages_Common$DvmAdminFrontendFr.no) + ")";
                          } else {
                            return "";
                          }
                        }))
                ];
        }));
  var match$1 = form.input.orderType;
  var tmp;
  var exit = 0;
  switch (match$1) {
    case /* SO */0 :
    case /* ES */8 :
    case /* RS */10 :
    case /* SM */11 :
    case /* AS */15 :
        tmp = [];
        break;
    case /* CL */1 :
    case /* VE */2 :
    case /* VD */3 :
    case /* RR */4 :
    case /* RC */5 :
    case /* PG */6 :
    case /* EP */7 :
    case /* RP */9 :
    case /* TT */12 :
    case /* AD */13 :
    case /* AP */14 :
    case /* NOTSET */16 :
        exit = 1;
        break;
    
  }
  if (exit === 1) {
    tmp = [
      React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.valueVO,
            children: Belt_Option.mapWithDefault(usedCarDetail$1.orderRealTradeAmount, "-", (function (eta) {
                    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                  })) + match[8]
          }),
      React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.estimatedValueVO,
            children: Belt_Option.mapWithDefault(usedCarDetail$1.orderEstimatedTradeAmount, "-", (function (eta) {
                    return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                  })) + match[9]
          }),
      React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
            label: Messages_Orders_Detail$DvmAdminFrontendFr.endOfLifeVO,
            children: Belt_Option.mapWithDefault(usedCarDetail$1.orderScrapyardIndicator, "-", (function (x) {
                    return intl.formatMessage(x ? Messages_Common$DvmAdminFrontendFr.yes : Messages_Common$DvmAdminFrontendFr.no);
                  })) + match[10]
          })
    ];
  }
  return React.createElement(Order_Detail_Correct_Box$DvmAdminFrontendFr.make, {
              content: Belt_Array.concat([
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.reprPoliceNumber,
                          children: Belt_Option.getWithDefault(usedCarDetail$1.ucPoliceNumber, "-") + match[0]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.registrationVO,
                          children: Belt_Option.getWithDefault(usedCarDetail$1.orderUcRegistrationId, "-") + match[2]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.registrationDate,
                          children: Belt_Option.mapWithDefault(usedCarDetail$1.orderUCLastRegistrationDate, "-", (function (param) {
                                  return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                })) + match[1]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Orders_Detail$DvmAdminFrontendFr.reprDatePremiere,
                          children: Belt_Option.mapWithDefault(usedCarDetail$1.orderUCFirstReleaseDate, "-", (function (param) {
                                  return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                })) + match[3]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.brandVO,
                          children: Belt_Option.getWithDefault(usedCarDetail$1.orderUcBrand, "-") + match[4]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.modelVO,
                          children: Belt_Option.getWithDefault(usedCarDetail$1.orderUcModel, "-") + match[5]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.versionVO,
                          children: Belt_Option.getWithDefault(usedCarDetail$1.orderUcVersion, "-") + match[6]
                        }),
                    React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                          label: Messages_Common$DvmAdminFrontendFr.vinVO,
                          children: Belt_Option.getWithDefault(usedCarDetail$1.orderUcVin, "-") + match[7]
                        })
                  ], tmp),
              color: color,
              title: title
            });
}

var make = Order_Detail_Correct_Vehicle_Content;

export {
  make ,
}
/* react Not a pure module */
